/* tslint:disable */
import icon from 'vue-svgicon'
icon.register({
  'glassthickness-minus': {
    width: 22,
    height: 22,
    viewBox: '0 0 22 22',
    data: `<defs><clipPath id="svgicon_glassthickness-minus_a"><path pid="0" d="M0 0h22v22H0z"/></clipPath></defs><g clip-path="url(#svgicon_glassthickness-minus_a)"><path pid="1" _fill="currentColor" d="M16.5 9.5v3h-11v-3z"/></g>`
  }
})
/* tslint:enable */
